/* eslint-disable jsx-a11y/alt-text */
import React, { FunctionComponent, useEffect, useState } from 'react';
import ReactCrop, { Crop } from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';
import { useParams } from 'react-router-dom';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { ImageDto } from '../../dto/LectionImageDto';
import { BackDropDiv } from '../backdrop/BackDropDiv';
import { IAlertProps } from '../../interface/IAlertProps';
import {
  generateFilname,
  getDefaultAlertProps,
  getPageNumId,
  secureContent,
} from '../../utils/utils';
import { RESOURCE_URL } from '../../setting/AppSettings';
import { MyAlert } from '../UI/MyAlert';
import { IApiResult } from '../../interface/IApiResult';
import { CropDto } from '../../dto/CropDto';
import { apiCropImage } from '../../service/apiCropImage';
import { API_STATUS_PROBLEM } from '../../constant/constants';
import { AlertSeverityEnum } from '../../enum/AlertSeverityEnum';

interface Props {
  idPage: string;
  open: boolean;
  dto: ImageDto;
  onSave: (e: any) => void;
  onClose: () => void;
}

export const DialogCropImage: FunctionComponent<Props> = ({
  idPage,
  open,
  dto,
  onSave,
  onClose,
}) => {
  const [crop, setCrop] = useState<Crop>();
  const [imageDto, setImageDto] = useState<ImageDto>(dto);
  const [cropDto, setCropDto] = useState<CropDto>({
    name: dto.name,
    x: 0,
    y: 0,
    w: 0,
    h: 0,
    name2: generateFilname(dto.name),
  });
  const [alertProps, setAlertProps] = useState<IAlertProps>(
    getDefaultAlertProps()
  );
  const [backDrop, setBackDrop] = useState(false);
  const handleClose = () => {
    onClose();
    setCropDto({
      name: '',
      x: 0,
      y: 0,
      w: 0,
      h: 0,
      name2: '',
    });
  };
  const handleSave = () => {
    onSave(cropDto);
  };
  const { section, route } = useParams();
  const page = getPageNumId(idPage);

  const onCrpChange = (e: Crop) => {
    setCrop(e);
    cropDto.x = e.x;
    cropDto.y = e.y;
    cropDto.h = e.height;
    cropDto.w = e.width;
    setCropDto(cropDto);
  };

  const handleSaveCrop = async () => {
    if (cropDto.w === 0 || cropDto.h === 0) {
      return;
    }
    setBackDrop(true);
    const apiResult: IApiResult = await apiCropImage(
      section ?? '',
      route ?? '',
      page ?? '',
      cropDto
    );
    if (apiResult.isSuccess) {
      handleSave();
      handleClose();
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
    setBackDrop(false);
  };

  useEffect(() => {
    if (open) {
      setImageDto(dto);
      setCropDto({
        name: dto.name,
        x: 0,
        y: 0,
        w: 0,
        h: 0,
        name2: generateFilname(dto.name),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <div>
      <BackDropDiv open={backDrop} />
      <Dialog
        open={open}
        fullWidth
        maxWidth="lg"
        style={{ userSelect: 'none' }}
        PaperProps={{
          sx: { backgroundColor: '#e7ebee', width: '100%' },
        }}
      >
        <MyAlert
          message={alertProps.message}
          severity={alertProps.severity}
          onClose={() => setAlertProps({ ...alertProps, message: '' })}
        />
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography
              style={{
                fontFamily: 'sans-serif',
                fontSize: '16px',
                textAlign: 'left',
                fontWeight: '600',
              }}
              component="text"
            >
              Редактирование изображения
            </Typography>
            <IconButton size="medium" onClick={handleClose}>
              <CloseIcon fontSize="medium" />
            </IconButton>
          </Stack>
        </DialogTitle>
        <DialogContent>
          <Stack spacing={1}>
            <ReactCrop crop={crop} onChange={(c) => onCrpChange(c)}>
              <img
                src={`https://uchianat.ru/api/contentUrl.php?section=${section}&lectionId=${route}&page=page_${page}&name=${
                  imageDto.name
                }&${secureContent()}`}
              />
            </ReactCrop>
            <Stack>
              <IconButton size="medium" onClick={() => handleSaveCrop()}>
                <SaveIcon
                  fontSize="medium"
                  sx={{
                    color: '#2196f3',
                  }}
                />
              </IconButton>
            </Stack>
          </Stack>
        </DialogContent>
      </Dialog>
    </div>
  );
};
